<script setup lang="ts">
import VaspWalletOnboardingContainer from './containers/VaspWalletOnboardingContainer.vue'
</script>

<template>
  <VaspWalletOnboardingContainer />
</template>
